import styled from "styled-components";
import { screenWidth } from "~/config/dimensions";

export const Image = styled.img`
  width: ${screenWidth(60)}px;
  height: ${screenWidth(60)}px;
  margin: ${screenWidth(5)}px;
`;
